/**
 * Si el host es una URL antigua dada de baja (*.food.smarty.lat / *.food.smarty.local)
 * o cualquier URL desconocida, redirige a la web principal de marketing.
 */

import { useEffect } from 'react';
import { isDeprecatedLegacyDomain } from '@/lib/domain';
import { getRootDomain } from '@/config/app-domains.config';
import { RedirectLoading } from '@/components/RedirectLoading';

function getMarketingUrl(): string {
  if (typeof window === 'undefined') return 'https://smarty.lat';
  const root = getRootDomain();
  const port = window.location.port && window.location.port !== '80' && window.location.port !== '443'
    ? `:${window.location.port}`
    : '';
  return `${window.location.protocol}//${root}${port}`;
}

export function LegacyDomainGate({ children }: { children: React.ReactNode }) {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const hostnameWithoutPort = hostname.split(':')[0];
  const isDeprecated = isDeprecatedLegacyDomain(hostnameWithoutPort);

  useEffect(() => {
    if (isDeprecated) {
      window.location.replace(getMarketingUrl());
    }
  }, [isDeprecated]);

  if (isDeprecated) {
    return <RedirectLoading />;
  }

  return <>{children}</>;
}
